// extracted by mini-css-extract-plugin
module.exports = {"MenuContainer":"RowActionMenu_MenuContainer__2SDPj","MenuItem":"RowActionMenu_MenuItem__3QkMj"};